export enum NetworkUserType {
  User = 'User',
  JobSeeker = 'JobSeeker',
}
